import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';
import BagsImg from '../../assets/images/bags-everywhere.jpg';
import './plastic.css';
const Plastic = () => {
  return (
    <Container fluid className='plastic__main__container'>
      <Container>
        <h1 className='plastic__h1 '>
          <AnimatedText
            type='chars' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            Plastic Everywhere
          </AnimatedText>
        </h1>
        <Row className='row__nm'>
          <Col md={4}>
            <img src={BagsImg} alt='bags' width='100%' className='bag__img' />
          </Col>
          <Col md={8}>
            <p className='plastic__p1'>
              Plastic has become a component of our ecosystem. Synthetic
              materials have become intertwined with every aspect of our lives -
              from medicine, food, and electronics, to the beauty and cosmetics
              industry. Plastics are a concern because they are
              non-biodegradable; hence, they accumulate in the environment.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Plastic;
